import './app'
import '../icons/icons.json';

(function (w, $) {

    const NhhSubMenuPage = () =>{
        const $menuSub = $('#nhh-menu-sub');
        if (!$menuSub.length) return;
        const $dataID =  $menuSub.data('sub-id');
        if($dataID){
            $menuSub.find('li.page_item').removeClass('active');
            $menuSub.find(`li.page-item-${$dataID}`).addClass('active');
        }
    }
	
    const NhhHeaderTopBar = () =>{
        // Header - Hamburger icon
		$('#nav-button').click(function(event){
			$('#nav-button').toggleClass('open');
			// $('#navbar-dropdown').css("height", $('body').height());
			$('#navbar-dropdown').fadeToggle('1500').toggleClass('menu-open');
		});
		if ($('#nav-button').is(':visible')) {
			$("#navbar-dropdown li.scroll a").addClass('scroll');
			$("#navbar-dropdown a.scroll").click(function(event){
				$('#nav-button').toggleClass('open');
				// $('#navbar-dropdown').css("height", $('body').height());
				$('#navbar-dropdown').fadeToggle('1500').toggleClass('menu-open');
				$('html, body').animate({
					scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top
				}, 1500);
				return false;
			});
		};

		// Header - Menu Add class to current menu item
		$('.header .menu li a').each(function() {
			if ($(this).prop('href') == window.location.href) {
				$(this).parent().addClass('current-menu-item');
			}
		});

		$(window).scroll(function() {
		   if ($(this).scrollTop() > 150){
		      $('header').addClass("not-top");
		   } else {
		      $('header').removeClass("not-top");
		   }
		});
    }

	const NhhHeaderMobile = () =>{
		const $buttonToggle = $('.main-navigation .navbar-toggler');

		$buttonToggle.click(function(){
			$(this).parents('.main-navigation').find('.navbar-collapse').toggleClass('active')
			$(this).parents('.main-navigation').find('.navbar-collapse').toggleClass('collapse')

			$(this).parents('.main-navigation').find('.menu-icon').toggleClass('active')
			$(this).parents('.main-navigation').toggleClass('is-open')
		});
	}

	const NhhHeaderHero = () =>{
		const $heroSs  = $('.home-header-hero');
		const $button  = $('.home-header-hero .slider-controls ul > li')
		if($button.length <= 0) return;
		let   $totalBt = $button.length
		$button.click(function(e){
			let $key = $(this).data('key');
			$button.removeClass('active')
			$(this).addClass('active')
			$heroSs.find('.home-header-item').removeClass('active')
			$heroSs.find(`.home-header-item.home-header-item-${$key}`).addClass('active')
		})

		setInterval(function(){
			__loopItem()
		}, 8000)

		function __loopItem(){
			
			let $itemCurrent = $('.home-header-hero .slider-controls ul > li.active').data('key')
			$button.removeClass('active');
			$heroSs.find('.home-header-item').removeClass('active')
			var $keyAc = $itemCurrent +  1 ;
			if($keyAc >= $totalBt){		
				$(`.home-header-hero .slider-controls ul > li.item-0`).addClass('active')
				$heroSs.find(`.home-header-item.home-header-item-0`).addClass('active')
			}else{
				$(`.home-header-hero .slider-controls ul > li.item-${$keyAc}`).addClass('active')
				$heroSs.find(`.home-header-item.home-header-item-${$keyAc}`).addClass('active')	
			}
		}
	}

   
    // Document ready
    $(document).ready(function () {
        // NhhHeaderTopBar()
        // NhhSubMenuPage()
		NhhHeaderMobile()
		NhhHeaderHero()
    });

    $(window).on('resize', function () {
        
    })

    // Browser load completed 
    $(w).load(function () {
        
    });
})(window, jQuery);
